<template>
  <main class="rh-colaborador">
    <rh-cabecalho
      pagina="pessoas"
      subtitulo="COLABORADOR"
      titulo=""
      :unidade-id="unidadeId"
      :empresas="empresas"
      mostrar-pessoas
      :mostrar-configuracao="podeAdministrar"
      @empresa-selecionada="selecionarEmpresa"
    />
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>
    <b-loading :active="loading" :is-full-page="false"></b-loading>
    <b-message v-if="!loading && unidadeId && !perfis.length" type="is-warning" :closable="false">
      Nenhum perfil de acesso disponível para esta empresa.
    </b-message>
    <b-message v-if="!loading && unidadeId && equipeObrigatoria && !equipes.length" type="is-warning" :closable="false">
      Cadastre uma equipe antes de salvar este colaborador.
    </b-message>
    <section v-if="!loading && unidadeId && (!edicao || pessoa.id)" class="rh-card">
      <div class="rh-profile-header">
        <img :src="fotoPreview" alt="Foto do colaborador" class="rh-profile-avatar">
        <div class="rh-profile-copy">
          <p class="rh-profile-eyebrow">{{ edicao ? 'CADASTRO DO COLABORADOR' : 'NOVO COLABORADOR' }}</p>
          <h1>{{ pessoa.nome || 'Novo colaborador' }}</h1>
          <p>{{ empresaAtual }}<span v-if="equipeAtual"> · {{ equipeAtual }}</span><span v-if="resumoCargo"> · {{ resumoCargo }}</span></p>
        </div>
        <div class="rh-profile-status">
          <b-tag :type="desativado ? 'is-danger' : 'is-success'">{{ desativado ? 'Desativado' : 'Ativo' }}</b-tag>
          <b-tag v-if="resumoSituacao" type="is-light">{{ resumoSituacao }}</b-tag>
          <b-tag :type="acessoAtivo ? 'is-info' : 'is-light'">{{ acessoAtivo ? 'Com acesso' : convitePendente ? 'Convite pendente' : 'Sem acesso' }}</b-tag>
        </div>
      </div>
      <ValidationObserver v-slot="{ handleSubmit, invalid }" slim>
        <form @submit.prevent="handleSubmit(salvar)">
      <b-tabs v-model="aba" type="is-boxed" expanded class="rh-tabs">
        <b-tab-item label="Informações Pessoais" icon="account">
          <div class="tile is-ancestor">
            <div class="tile is-parent is-vertical is-9">
              <article class="tile is-child box rh-form-panel">
                <h2 class="rh-section-title">Cadastro básico</h2>
                <p class="rh-form-intro">Identificação, contatos de acesso e vínculos já existentes no MetaVirtue.</p>
                <div class="columns">
                  <div class="column">
                    <ValidationProvider v-slot="{ errors, valid }" name="Nome" rules="required|min:2|max:40">
                      <b-field label="Nome" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input v-model.trim="pessoa.nome" maxlength="40" :has-counter="false"></b-input>
                      </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Apelido"><b-input v-model.trim="pessoa.apelido" maxlength="100" :has-counter="false"></b-input></b-field>
                  </div>
                  <div class="column">
                    <b-field label="Código Externo"><b-input :value="pessoa.codigoExterno" disabled></b-input></b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <ValidationProvider v-slot="{ errors, valid }" name="Perfil" rules="required">
                      <b-field label="Nível" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-select v-model="pessoa.nivelId" expanded placeholder="Selecione um perfil" :disabled="!podeAdministrar">
                          <option v-for="perfil in perfis" :key="perfil.id" :value="perfil.id">{{ perfil.nome }}</option>
                        </b-select>
                      </b-field>
                    </ValidationProvider>
                  </div>
                  <div class="column">
                    <b-field label="Usuário"><b-input v-model.trim="pessoa.usuario" maxlength="40" :has-counter="false" :disabled="!podeAdministrar"></b-input></b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column"><b-field label="CPF"><b-input v-model="pessoa.cpf" v-mask="'###.###.###-##'" maxlength="14" :has-counter="false"></b-input></b-field></div>
                  <div class="column">
                    <ValidationProvider v-slot="{ errors, valid }" name="Email" rules="required|email">
                      <b-field label="Email" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input v-model.trim="pessoa.email" type="email" maxlength="50" :has-counter="false"></b-input>
                      </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="columns">
                  <div class="column"><b-field label="Fone"><b-input v-model="pessoa.fone" v-mask="['(##) ####-####', '(##) #####-####']" maxlength="20" :has-counter="false"></b-input></b-field></div>
                  <div class="column"><b-field label="Celular"><b-input v-model="pessoa.celular" v-mask="['(##) ####-####', '(##) #####-####']" maxlength="15" :has-counter="false"></b-input></b-field></div>
                </div>
                <div class="columns">
                  <div class="column">
                    <ValidationProvider v-slot="{ errors, valid }" name="Equipe" :rules="equipeObrigatoria ? 'required' : ''">
                      <b-field label="Equipe" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-select v-model="pessoa.equipeId" expanded placeholder="Selecione uma equipe">
                          <option v-if="podeAdministrar && !equipeObrigatoria" :value="null">Definir depois</option>
                          <option v-for="equipe in equipes" :key="equipe.id" :value="equipe.id">
                            {{ equipe.nome }} · {{ equipe.area }}
                          </option>
                        </b-select>
                      </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <rh-colaborador-detalhes v-if="podeAdministrar" ref="pessoal" tipo="pessoal" :funcionario-id="pessoa.id" :unidade-id="unidadeId" />
              </article>
            </div>
            <div class="tile is-parent">
              <div class="tile is-child rh-side-panels">
                <aside class="panel rh-access-panel">
                  <p class="panel-heading has-text-centered">Foto</p>
                  <div class="panel-block rh-photo-block"><img :src="fotoPreview" alt="Foto do colaborador" class="rh-photo"></div>
                  <div class="panel-block"><input type="file" accept="image/jpeg,image/png" @change="selecionarFoto"></div>
                  <div v-if="edicao && podeAdministrar" class="panel-block"><b-switch v-model="desativado" type="is-danger">Desativado</b-switch></div>
                </aside>
                <aside v-if="edicao" class="panel rh-access-panel">
                  <p class="panel-heading has-text-centered">Histórico de alterações</p>
                  <div class="panel-block"><b-button type="is-info" expanded icon-left="clock" @click="abrirHistorico">Ver histórico</b-button></div>
                </aside>
                <aside v-if="podeAdministrar" class="panel rh-access-panel">
                  <p class="panel-heading has-text-centered">{{ acessoAtivo ? 'Redefinir Senha' : 'Definir Senha' }}</p>
                  <div class="panel-block rh-password-block">
                    <b-field label="Nova Senha" expanded><b-input v-model="novaSenha" type="password" password-reveal maxlength="128" :has-counter="false"></b-input></b-field>
                    <p class="rh-muted">Mínimo de 6 caracteres.</p>
                  </div>
                </aside>

              </div>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item v-if="podeAdministrar" label="Endereços e Contatos" icon="map-marker">
          <rh-colaborador-detalhes ref="endereco" tipo="endereco" :funcionario-id="pessoa.id" :unidade-id="unidadeId" />
        </b-tab-item>
        <b-tab-item v-if="podeAdministrar" label="Dependentes" icon="account-multiple">
          <rh-colaborador-detalhes ref="dependentes" tipo="dependentes" :funcionario-id="pessoa.id" :unidade-id="unidadeId" />
        </b-tab-item>
        <b-tab-item label="Dados Profissionais" icon="briefcase">
          <rh-colaborador-detalhes v-if="podeAdministrar" ref="profissional" tipo="profissional" :funcionario-id="pessoa.id" :unidade-id="unidadeId" />
          <p v-else class="rh-save-first">Os dados profissionais de RH são restritos à diretoria.</p>
        </b-tab-item>
        <b-tab-item v-if="podeAdministrar" label="Documentos" icon="file-document">
          <rh-colaborador-detalhes ref="documentos" tipo="documentos" :funcionario-id="pessoa.id" :unidade-id="unidadeId" />
        </b-tab-item>
      </b-tabs>
      <b-message v-if="invalid" type="is-warning" :closable="false">Verifique os campos destacados nas abas antes de salvar.</b-message>
      <nav class="level rh-form-actions">
        <div class="level-item">
          <div class="buttons">
            <b-button native-type="submit" type="is-success" icon-left="check-circle" :loading="salvando" :disabled="!perfis.length">Salvar</b-button>
            <b-button native-type="button" type="is-danger" icon-left="close-circle" @click="voltar">Cancelar</b-button>
          </div>
        </div>
      </nav>
        </form>
      </ValidationObserver>
    </section>
    <b-modal :active.sync="historicoAberto" has-modal-card>
      <div class="modal-card rh-history-modal">
        <header class="modal-card-head"><p class="modal-card-title">Histórico de alterações</p></header>
        <section class="modal-card-body">
          <b-loading :active="historicoCarregando" :is-full-page="false"></b-loading>
          <p v-if="!historicoCarregando && !historico.length">Nenhuma alteração registrada.</p>
          <div v-for="(item, index) in historico" :key="index" class="rh-history-row"><strong>{{ item.acao }}</strong> · {{ formatarData(item.dataHora) }}<br><small>{{ item.usuario }}</small></div>
        </section>
        <footer class="modal-card-foot"><b-button @click="historicoAberto = false">Fechar</b-button></footer>
      </div>
    </b-modal>
  </main>
</template>

<script>
import http from '@/http'
import RhCabecalho from '@/components/rh_cabecalho.vue'
import RhColaboradorDetalhes from '@/components/rh_colaborador_detalhes.vue'
import fotoPadrao from '@/assets/pessoa.png'
import { mapGetters } from 'vuex'

function novaPessoa() {
  return { id: null, nome: '', apelido: '', codigoExterno: '', nivelId: null, usuario: '', cpf: '', email: '', fone: '', celular: '', equipeId: null, foto: null }
}

export default {
  name: 'RhColaborador',
  components: { RhCabecalho, RhColaboradorDetalhes },
  data() {
    return {
      empresas: [],
      unidadeId: null,
      equipes: [],
      perfis: [],
      pessoa: novaPessoa(),
      fotoPreview: fotoPadrao,
      novaSenha: '',
      usuarioOriginal: '',
      desativado: false,
      historico: [],
      historicoAberto: false,
      historicoCarregando: false,
      acessoAtivo: false,
      resumoCargo: '',
      resumoSituacao: '',
      convitePendente: false,
      loading: false,
      salvando: false,
      aba: 0,
      erro: '',
    }
  },
  computed: {
    ...mapGetters(['isInRole']),
    edicao() {
      return !!this.$route.params.id
    },
    podeAdministrar() {
      return this.isInRole('rh-diretoria')
    },
    equipeObrigatoria() {
      const perfil = this.perfis.find((x) => x.id === this.pessoa.nivelId)
      return !this.podeAdministrar || (!this.pessoa.id && !!(perfil && perfil.regras.includes('rh-colaborador')))
    },
    empresaAtual() {
      const empresa = this.empresas.find((x) => x.id === this.unidadeId)
      return empresa ? empresa.nome : 'Empresa'
    },
    equipeAtual() {
      const equipe = this.equipes.find((x) => x.id === this.pessoa.equipeId)
      return equipe ? `${equipe.area} · ${equipe.nome}` : ''
    },
  },
  created() {
    this.iniciar()
  },
  methods: {
    atualizarResumoProfissional(dados) { this.resumoCargo = dados.cargo; this.resumoSituacao = dados.situacao },
    async carregarPerfis() {
      const perfis = []
      let pagina = 1
      let totalPaginas
      do {
        const { data } = await http.get('/api/manutencao/niveisdeacesso', {
          params: { unidadeId: this.unidadeId, page: pagina },
        })
        perfis.push(...(data.lista || []))
        totalPaginas = data.pageCount || 0
        pagina += 1
      } while (pagina <= totalPaginas)
      return perfis
    },
    falha(e) {
      this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível concluir a operação. Tente novamente.'
    },
    voltar() {
      this.$router.push({ name: 'rh-pessoas', query: { unidadeId: this.unidadeId } })
    },
    selecionarEmpresa(id) {
      if (this.edicao) {
        this.$router.push({ name: 'rh-pessoas', query: { unidadeId: id } })
        return
      }
      this.unidadeId = id
      this.$router.replace({ name: 'rh-colaborador-novo', query: { unidadeId: id } })
      this.pessoa = novaPessoa()
      this.aba = 0
      this.fotoPreview = fotoPadrao
      this.novaSenha = ''
      this.usuarioOriginal = ''
      this.resumoCargo = ''
      this.resumoSituacao = ''
      this.carregar()
    },
    async iniciar() {
      this.loading = true
      try {
        this.empresas = (await http.get('/api/rh/estrutura/empresas')).data || []
        const unidadeRota = Number(this.$route.query.unidadeId)
        const unidadeAtual = Number(this.$store.state.unidadeId)
        this.unidadeId = this.empresas.some((x) => x.id === unidadeRota)
          ? unidadeRota
          : this.empresas.some((x) => x.id === unidadeAtual)
          ? unidadeAtual
          : (this.empresas[0] && this.empresas[0].id) || null
        if (!this.unidadeId) {
          this.erro = 'Nenhuma empresa disponível para o seu perfil.'
          return
        }
        await this.carregar()
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    async carregar() {
      if (!this.unidadeId) return
      this.loading = true
      this.erro = ''
      try {
        const params = { unidadeId: this.unidadeId }
        const requisicoes = [
          http.get('/api/rh/estrutura/equipes', { params }),
          this.carregarPerfis(),
          http.get('/api/rh/pessoas/perfis', { params }),
        ]
        const id = Number(this.$route.params.id)
        if (this.edicao) requisicoes.push(http.get(`/api/rh/pessoas/colaboradores/${id}`, { params }))
        const [equipes, perfis, perfisRh, detalhe] = await Promise.all(requisicoes)
        this.equipes = equipes.data || []
        const regrasPorPerfil = new Map((perfisRh.data || []).map((perfil) => [perfil.id, perfil.regras]))
        this.perfis = perfis.map((perfil) => ({ ...perfil, regras: regrasPorPerfil.get(perfil.id) || [] }))
        if (!this.edicao) {
          this.pessoa.equipeId = this.podeAdministrar ? null : (this.equipes[0] && this.equipes[0].id) || null
          if (!this.podeAdministrar) {
            const perfilColaborador = this.perfis.find((perfil) => perfil.regras.length === 1 && perfil.regras[0] === 'rh-colaborador')
            this.pessoa.nivelId = perfilColaborador ? perfilColaborador.id : null
          }
          return
        }
        const item = detalhe.data
        let equipeId = null
        const vinculos = await Promise.all(this.equipes.map((equipe) =>
          http.get('/api/rh/estrutura/membros', { params: { unidadeId: this.unidadeId, equipeId: equipe.id } })))
        const indice = vinculos.findIndex((resposta) => (resposta.data || []).some((membro) => membro.id === id))
        equipeId = indice >= 0 ? this.equipes[indice].id : null
        this.pessoa = { ...novaPessoa(), ...item, equipeId }
        this.usuarioOriginal = item.usuario || ''
        this.fotoPreview = item.temFoto ? `/api/rh/pessoas/colaboradores/${id}/foto?unidadeId=${this.unidadeId}` : fotoPadrao
        this.acessoAtivo = item.temAcesso
        this.convitePendente = item.convitePendente
        if (this.podeAdministrar) {
          const profissional = await http.get(`/api/rh/colaboradores/${id}/profissional`, { params }).catch(() => null)
          this.resumoCargo = profissional && profissional.data ? profissional.data.cargo || '' : ''
          this.resumoSituacao = profissional && profissional.data ? profissional.data.situacao || '' : ''
        }
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    selecionarFoto(evento) {
      const arquivo = evento.target.files && evento.target.files[0]
      if (!arquivo) return
      if (!['image/jpeg', 'image/png'].includes(arquivo.type) || arquivo.size > 2 * 1024 * 1024) {
        this.erro = 'Selecione uma foto JPEG ou PNG de até 2 MB.'
        evento.target.value = ''
        return
      }
      const leitor = new FileReader()
      leitor.onload = () => { this.pessoa.foto = leitor.result; this.fotoPreview = leitor.result }
      leitor.onerror = () => { this.erro = 'Não foi possível ler a foto.' }
      leitor.readAsDataURL(arquivo)
    },
    async abrirHistorico() {
      this.historicoAberto = true
      this.historicoCarregando = true
      try {
        this.historico = (await http.get(`/api/rh/pessoas/colaboradores/${this.pessoa.id}/historico`, { params: { unidadeId: this.unidadeId } })).data || []
      } catch (e) { this.falha(e); this.historicoAberto = false } finally { this.historicoCarregando = false }
    },
    formatarData(data) { return data ? new Date(data).toLocaleString('pt-BR') : '' },
    async desativar() {
      this.salvando = true
      try {
        await http.post(`/api/rh/pessoas/colaboradores/${this.pessoa.id}/desativar?unidadeId=${this.unidadeId}`)
        this.$buefy.toast.open({ message: 'Colaborador desativado.', type: 'is-success' })
        this.voltar()
      } catch (e) { this.desativado = false; this.falha(e) } finally { this.salvando = false }
    },
    async salvar() {
      const perfil = this.perfis.find((x) => x.id === this.pessoa.nivelId)
      if ((!this.podeAdministrar || (!this.pessoa.id && perfil && perfil.regras.includes('rh-colaborador'))) && !this.pessoa.equipeId) {
        this.erro = 'Selecione uma equipe para o colaborador.'
        return
      }
      if (this.desativado) {
        this.$buefy.dialog.confirm({ title: 'Desativar colaborador', message: 'O acesso e os vínculos ativos com equipes serão encerrados. Alterações nos demais campos não serão salvas. Deseja continuar?', type: 'is-danger', onConfirm: () => this.desativar() })
        return
      }
      const usuario = (this.pessoa.usuario || '').trim()
      const alterarConta = this.podeAdministrar && (this.novaSenha || (this.acessoAtivo && usuario !== this.usuarioOriginal) || (!this.acessoAtivo && usuario))
      if (alterarConta && (!usuario || (!this.acessoAtivo && !this.novaSenha) || (this.novaSenha && this.novaSenha.length < 6))) {
        this.erro = 'Para criar acesso, informe usuário e senha com pelo menos 6 caracteres.'
        return
      }
      this.salvando = true
      this.erro = ''
      let salvoId = this.pessoa.id
      let basicoSalvo = false
      let etapa = 'cadastro básico'
      try {
        const { id, nome, apelido, cpf, email, fone, celular, nivelId, equipeId, foto } = this.pessoa
        const salvo = await http.post('/api/rh/pessoas/colaboradores', { id, nome, apelido, cpf, email, fone, celular, nivelId, equipeId, foto, unidadeId: this.unidadeId })
        salvoId = salvo.data.id
        basicoSalvo = true
        this.pessoa.id = salvoId
        if (this.podeAdministrar) {
          const abas = [
            ['Informações pessoais', this.$refs.pessoal],
            ['Endereços e contatos', this.$refs.endereco],
            ['Dependentes', this.$refs.dependentes],
            ['Dados profissionais', this.$refs.profissional],
            ['Documentos', this.$refs.documentos],
          ]
          for (const [nomeAba, componente] of abas) {
            etapa = nomeAba
            if (componente) await componente.salvarPendente(salvoId)
          }
        }
        if (alterarConta) {
          etapa = 'acesso'
          await http.post(`/api/rh/pessoas/colaboradores/${salvoId}/conta`, { unidadeId: this.unidadeId, usuario, senha: this.novaSenha })
          this.usuarioOriginal = usuario
          this.acessoAtivo = true
          this.novaSenha = ''
        }
        this.$buefy.toast.open({ message: 'Colaborador salvo.', type: 'is-success' })
        if (!this.edicao) await this.$router.replace({ name: 'rh-colaborador-editar', params: { id: salvoId }, query: { unidadeId: this.unidadeId } })
        etapa = 'atualização da tela'
        await this.carregar()
      } catch (e) {
        const motivo = e && e.data && e.data.erro
          ? e.data.erro
          : e && e.status === 403
            ? 'Você não tem permissão para alterar o acesso deste colaborador.'
            : e && e.status >= 500
              ? `Erro no servidor (HTTP ${e.status}). Consulte os logs da API.`
              : 'tente novamente.'
        this.erro = basicoSalvo ? `Cadastro básico salvo, mas não foi possível concluir ${etapa}: ${motivo} As alterações ainda pendentes permanecem na tela.` : motivo
        if (basicoSalvo && !this.edicao) await this.$router.replace({ name: 'rh-colaborador-editar', params: { id: salvoId }, query: { unidadeId: this.unidadeId } })
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style scoped>
.rh-colaborador {
  --navy: #0b1a3e;
  --blue: #007bff;
  --teal: #0e8fa8;
  background: #f4f3f0;
  min-height: 100vh;
  padding: 0 28px 48px;
  border-radius: 18px;
  color: #1c1d24;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-card {
  margin: 16px 0;
}
.rh-profile-header { display: flex; align-items: center; gap: 20px; padding: 24px 28px; margin-bottom: 22px; background: #fff; border: 1px solid #e7e9ed; border-radius: 17px; box-shadow: 0 8px 20px rgba(11, 26, 62, .04); }
.rh-profile-avatar { width: 74px; height: 74px; border-radius: 18px; object-fit: cover; background: #eef2f5; }
.rh-profile-copy { flex: 1; min-width: 0; }
.rh-profile-eyebrow { color: #0e8fa8; font-size: 11px; font-weight: 700; letter-spacing: .12em; }
.rh-profile-copy h1 { color: #0b1a3e; font-size: 24px; font-weight: 700; line-height: 1.2; margin: 4px 0; }
.rh-profile-copy p:last-child { color: #667085; font-size: 13px; }
.rh-profile-status { display: flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }
.rh-save-first { padding: 30px; text-align: center; color: #667085; background: #fff; border-radius: 17px; }
.rh-tabs { margin-top: 4px; }
.rh-tabs ::v-deep .tabs { margin-bottom: 0; }
.rh-tabs ::v-deep .tabs a { font-weight: 600; white-space: nowrap; }
.rh-tabs ::v-deep .tab-content { padding: 18px 0 0; }
.rh-form-panel,
.rh-access-panel {
  background: #fff;
  border: 1px solid #e7e9ed;
  border-radius: 17px;
  box-shadow: 0 8px 20px rgba(11, 26, 62, 0.04);
}
.rh-form-panel {
  padding: 28px;
}
.rh-form-intro { margin: -10px 0 22px; color: #667085; font-size: 13px; }
.rh-side-panels { display: flex; flex-direction: column; gap: 16px; }
.rh-photo-block { justify-content: center; }
.rh-photo { display: block; max-width: 100%; max-height: 300px; object-fit: cover; }
.rh-password-block { display: block; }
.rh-history-modal { width: min(560px, 95vw); }
.rh-history-row { padding: 12px 0; border-bottom: 1px solid #e7e9ed; }
.rh-section-title {
  color: var(--navy);
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.rh-access-panel {
  overflow: hidden;
}
.rh-access-content {
  display: block;
  padding: 20px;
}
.rh-muted {
  color: #667085;
  font-size: 13px;
  margin-top: 14px;
}
.rh-form-actions {
  margin-top: 20px;
}
@media (max-width: 640px) {
  .rh-colaborador { padding: 0 14px 30px; }
  .rh-form-panel { padding: 18px; }
  .rh-profile-header { padding: 18px; flex-wrap: wrap; }
  .rh-profile-copy h1 { font-size: 20px; }
  .rh-profile-status { width: 100%; justify-content: flex-start; }
  .rh-tabs ::v-deep .tabs { overflow-x: auto; }
  .rh-tabs ::v-deep .tabs li { flex-shrink: 0; }
}
</style>
